/* istanbul ignore file */
/* istanbul ignore file */
import { LinkField, useFieldHelper } from 'framework/ui/field';
import React from 'react';
import useRedmineUrl from 'infrastructure/integrations/redmine/useRedmineUrl';

// @ts-ignore
const RedmineUserField = ({ source, nameSource, ...props }) => {
  const { getValue: getId } = useFieldHelper<number>({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getUserUrl } = useRedmineUrl();

  const id = getId();
  const name = getName();
  const value = id && getUserUrl(id);

  return <LinkField {...props} linkText={name} value={value as string} isInternal={false} />;
};

export default RedmineUserField;
